export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGOUT_LOADING = "LOGOUT_LOADING";
export const LOG_OUT = "LOG_OUT";
export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_FAILED = "SIGNUP_FAILED";
export const SIGNUP_LOADING = "SIGNUP_LOADING";

// cv prototype
export const CV_LOADING = "CV_LOADING";
export const GENERATING_CV_FAILED = "GENERATING_CV_FAILED";
export const CV_GENERATED_SUCCESSFULLY = "CV_GENERATED_SUCCESSFULLY"

// existing cv
export const EXISTING_CV_LOADING = "EXISTING_CV_LOADING";
export const GENERATING_EXISTING_CV_FAILED = "GENERATING_EXISTING_CV_FAILED";
export const EXISTING_CV_GENERATED_SUCCESSFULLY = "EXISTING_CV_GENERATED_SUCCESSFULLY"

// cv id
export const CV_ID = 'CV_Id';
export const CV_ID_LOADING = "CV_ID_LOADING";
export const CV_PICS = 'CV_PICS';

// user's info
export const USER_NAME_DB = "USER_NAME_DB";
export const LOADING_USER_NAME = "LOADING_USER_NAME"

// Saving Cv details prototype
export const GETTING_CV_LOADING = "GETTING_CV_LOADING"
export const GETTING_CV_FAILED = "GETTING_CV_FAILED";
export const GETTING_CV_SUCCESS = "GETTING_CV_SUCCESS";

// creating user profile
export const GET_PROFILE_LOADING = "GET_PROFILE_LOADING"
export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";

// creating user profile
export const GET_EMPLOYER_PROFILE_LOADING = "GET_EMPLOYER_PROFILE_LOADING"
export const GET_EMPLOYER_PROFILE_FAILED = "GET_EMPLOYER_PROFILE_FAILED";
export const GET_EMPLOYER_PROFILE_SUCCESS = "GET_EMPLOYER_PROFILE_SUCCESS";

// employee public account view
export const GET_PUBLIC_PROFILE_LOADING = "GET_PUBLIC_PROFILE_LOADING"
export const GET_PUBLIC_PROFILE_FAILED = "GET_PUBLIC_PROFILE_FAILED";
export const GET_PUBLIC_PROFILE_SUCCESS = "GET_PUBLIC_PROFILE_SUCCESS";


// verify mail
export const V_MAIL_LOADING = "V_MAIL_LOADING"
export const V_MAIL_FAILED = "V_MAIL_FAILED"
export const V_MAIL_SUCCESS = "V_MAIL_SUCCESS"

//  reset password
export const R_SET_LOADING = "V_MAIL_LOADING"
export const R_SET_FAILED = "R_SET_FAILED"
export const R_SET_SUCCESS = "R_SET_SUCCESS"

export const ACTIVITIES = "ACTIVITIES";
export const ACTIVITIES_LOADING = "ACTIVITIES_LOADING";

export const SKILLS = "SKILLS";
export const SKILLS_LOADING = "SKILLS_LOADING";

export const JOBTITLE = "JOBTITLE";
export const JOBTITLE_LOADING = "JOBTITLE_LOADING";

export const PROFESSIONAL_SUMMMARY = "PROFESSIONAL_SUMMMARY";
export const PROFESSIONAL_SUMMMARY_LOADING = "PROFESSIONAL_SUMMMARY_LOADING";

export const EDUCATION = "EDUCATION";
export const EDUCATION_LOADING = "EDUCATION_LOADING";

export const PERSONAL_SKILLS = "PERSONAL_SKILLS";
export const PERSONAL_SKILLS_LOADING = "PERSONAL_SKILLS_LOADING";

export const VOLUNTARY = "VOLUNTARY";
export const VOLUNTARY_LOADING = "VOLUNTARY_LOADING";


export const AWARD = "AWARD";
export const AWARD_LOADING = "AWARD_LOADING";

export const REFERENCE = "REFERENCE";
export const REFERENCE_LOADING = "REFERENCE_LOADING";

export const LANGUAGE = "LANGUAGE";
export const LANGUAGE_LOADING = "LANGUAGE_LOADING";

export const INDIVIDUAL_EXPERIENCE = "INDIVIDUAL_EXPERIENCE";
export const INDIVIDUAL_EXPERIENCE_LOADING = "INDIVIDUAL_EXPERIENCE_LOADING";
export const INDIVIDUAL_EXPERIENCE_ERROR = "INDIVIDUAL_EXPERIENCE_ERROR";

export const LANGUAGE_TRANSLATION = "LANGUAGE_TRANSLATION";
export const LANGUAGE_TRANSLATION_LOADING = "LANGUAGE_TRANSLATION_LOADING";

export const PERSONAL_INFO = "PERSONAL_INFO";
export const PERSONAL_INFO_LOADING = "PERSONAL_INFO_LOADING";
export const PERSONAL_INFO_FAILED = "PERSONAL_INFO_FAILED";

export const CERT = "CERT";
export const CERT_LOADING = "CERT_LOADING";

export const LANG = "LANG";
export const LANG_LOADING = "LANG_LOADING";

export const RESUME_STEP_ADD = "RESUME_STEP_ADD";
export const RESUME_STEP_SUB = "RESUME_STEP_SUB";
export const RESUME_STEP_JUMP = "RESUME_STEP_JUMP";

export const SPANISH = "SPANISH";
export const SPANISH_LOADING = "SPANISH_LOADING";

export const ABOUT = "ABOUT";
export const ABOUT_LOADING = "ABOUT_LOADING";
export const ABOUT_FAILED = "ABOUT_FAILED";

export const LANG_TYPE = "LANG_TYPE";
export const LANG_TYPE_S = "LANG_TYPE_S";

export const LAST_RESUME = "LAST_RESUME";
export const LAST_RESUME_LOADING = "LAST_RESUME_LOADING";

export const SECRET = "SECRET";
export const SECRET_LOADING = "SECRET_LOADING";

export const SAVE_LINK = "SAVE_LINK"
export const SAVE_LINK_LOADING = "SAVE_LINK_LOADING"


